<template>
  <div>
    <b-card>
      <div
        class="d-flex justify-content-start align-items-center m-2"
      >
        <div class="profile-user-info">
          <h2 class="mb-0">
            Boletín Financiero
          </h2>
        </div>
      </div>
      <b-card-text class="m-2">
        El Boletín Financiero es una difusión periódica vía red de cómputo dirigida a servidores públicos hacendarios, cuyo contenido son noticias de interés, acuerdos, reformas y/o decretos publicados en el Diario Oficial de la Federación, y en algunos casos, artículos, notas de interés, fichas técnicas, etcétera, escritos por personal que labora en INDETEC, que competen a la Hacienda Pública, el cual tiene como objetivo mantener informados a los servidores públicos hacendarios para contribuir a un mejor desempeño de la hacienda pública municipal, estatal y federal.
      </b-card-text>

      <!-- likes comments  share-->
      <b-row class="pb-50 mt-50 ml-2">
        <b-col
          sm="8"
          class="d-flex justify-content-between justify-content-sm-start mb-2"
        >
          <feather-icon
            icon="CheckCircleIcon"
            class="mr-50"
            size="18"
          />
          <span class="mr-1">
            Reserva de Derechos al Uso Exclusivo 04-2020-041512575400-203, ISSN: en trámite
          </span>
        </b-col>
        <b-col
          sm="4"
          class="d-flex justify-content-between justify-content-sm-end align-items-center mb-2"
        >
          <feather-icon
            icon="BookOpenIcon"
            class="mr-50 text-muted"
            size="18"
          />
          <span class="text-muted mr-1">{{ totalEdiciones }} Publicaciones </span>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol,
} from 'bootstrap-vue'
import store from '@/store'
import { computed } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
  },
  setup() {
    const totalEdiciones = computed(() => store.state.ediciones.fullItems.length)

    return {
      totalEdiciones,
    }
  },
}
</script>
